import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from 'react-redux';
import { FormControl, MenuItem,FormHelperText} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { traerAfiliacionesAutogestion } from "../../../actions/abm/abmAfiliaciones";
import {SelectValidator} from 'react-material-ui-form-validator';
import { traerConfiguracionPorCategoriaAutogestion } from "../../../actions/configuraciones/ConfiguracionCategoria";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  botonera: {
    marginTop: 25,
  },
}));

export const CboCategoriaAutogestion = React.memo((props) => {
    const [listaCateg, setListaCat] = useState([]);
    const classes = useStyles();
    const {items} = useSelector( state => state.categorias );
    const dispatch = useDispatch();

    useEffect(() => {
      if(items?.length>0)
     {
      let catFromState = items.map((cat) => {
        return {
          value: cat.id_sr,
          display: cat.descripcion_sr,
        };
      });
      setListaCat(catFromState);
     }
     dispatch(traerAfiliacionesAutogestion());
     // eslint-disable-next-line
    }, [items]);

    const onChange = (e) => {
      dispatch(traerConfiguracionPorCategoriaAutogestion(e.target.value));
    }

    return (
      <>
        <FormControl
          className={classes.formSelect}
          margin="normal"
          fullWidth={true}
          error={props.valuesValidation["id_sit_revista"]}
          disabled={props.deshabilitado}
        >
          <SelectValidator
            fullWidth={true}
            value={props.valor}
            name="id_sit_revista"
            disabled={props.idPanel==='idTabConsulta'?true:false}
            onChange={(e) => {
              onChange(e);
              props.manejadorInputChange(e);
              props.manejadorInputChangeValidation(e);
            }}
            label="Categoria"
            validators={['required']}
            errorMessages={['seleccione una opcion']}
          >
            <MenuItem value={-1}>
              <em>Seleccione</em>
            </MenuItem>
            {listaCateg.map((cat) => (
              (cat.value===0 || cat.value===5  || cat.value===7)&&<MenuItem key={cat.value} value={cat.value}>
                {cat.display}
              </MenuItem>
            ))}
          </SelectValidator>
          {props.valuesValidation["id_sit_revista"] && <FormHelperText>Obligatorio</FormHelperText>}
        </FormControl>
      </>
    );
  });
  